'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchPasswordResetCodeDetails = exports.passwordChangeSubmitted = exports.passwordChangeCodeNotFound = undefined;

var _httpStatusCodes = require('http-status-codes');

var _httpStatusCodes2 = _interopRequireDefault(_httpStatusCodes);

var _passwordService = require('../../password/passwordService');

var _changePasswordConstants = require('./changePasswordConstants');

var CHANGE_PASSWORD_ACTION_TYPES = _interopRequireWildcard(_changePasswordConstants);

var _errorConstants = require('../../../../common/error/errorConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
// Lib
var passwordChangeFailed = function passwordChangeFailed(error) {
    return {
        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_FAILED,
        error: error
    };
};

// Services


var passwordChangeCodeExpired = function passwordChangeCodeExpired() {
    return {
        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_CODE_EXPIRED
    };
};

var passwordChangeCodeNotFound = exports.passwordChangeCodeNotFound = function passwordChangeCodeNotFound() {
    return passwordChangeFailed({
        message: 'A code must be provided',
        description: 'In order to reset a password a code must be provided with the reset link.',
        code: 'NO_RESET_CODE'
    });
};

var passwordChangeCodeInvalid = function passwordChangeCodeInvalid() {
    return passwordChangeFailed({
        message: 'The code provided is invalid',
        description: "There's something wrong with your reset code, please try following " + 'the link within your reset password email again.',
        code: 'INVALID_RESET_CODE'
    });
};

var passwordChangeInitialised = function passwordChangeInitialised(_ref) {
    var email = _ref.email,
        code = _ref.code;
    return {
        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_INITIALISED,
        email: email,
        code: code
    };
};

var passwordChanged = function passwordChanged() {
    return {
        type: CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGED
    };
};

var passwordChangeSubmitted = exports.passwordChangeSubmitted = function passwordChangeSubmitted(_ref2) {
    var password = _ref2.password;
    return function (dispatch, getState) {
        var state = getState();
        var email = state.getIn(['app', 'modal', 'changePassword', 'email']);
        var code = state.getIn(['app', 'modal', 'changePassword', 'code']);

        return (0, _passwordService.changePassword)({ email: email, code: code, password: password }).then(function (res) {
            return dispatch(passwordChanged());
        }).catch(function (err) {
            var status = err.response && err.response.status;

            switch (status) {
                case _httpStatusCodes2.default.NOT_FOUND:
                    return dispatch(passwordChangeCodeExpired());
                case _httpStatusCodes2.default.BAD_REQUEST:
                    // Allow the password error to display on screen
                    // On validation errors respond with a structure that the form can react to
                    if (err.response.data.error && err.response.data.error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE && !!err.response.data.error.details.password) {
                        return Promise.reject(err.response.data.error.details);
                    }

                    // Otherwise treat it as a generic error
                    dispatch(passwordChangeFailed({
                        code: err.response.code || err.response.status
                    }));
                    break;
                default:
                    dispatch(passwordChangeFailed({
                        code: err.response ? err.code || err.status : undefined
                    }));
            }
        });
    };
};

var fetchPasswordResetCodeDetails = exports.fetchPasswordResetCodeDetails = function fetchPasswordResetCodeDetails(code) {
    return function (dispatch) {
        (0, _passwordService.getResetEmail)(code).then(function (email) {
            return dispatch(passwordChangeInitialised({ email: email, code: code }));
        }).catch(function (err) {
            var status = err.response && err.response.status;

            switch (status) {
                case _httpStatusCodes2.default.NOT_FOUND:
                    return dispatch(passwordChangeCodeExpired());
                case _httpStatusCodes2.default.BAD_REQUEST:
                    return dispatch(passwordChangeCodeInvalid());
                default:
                    return dispatch(passwordChangeFailed({
                        code: err.response ? err.code || err.status : undefined
                    }));
            }
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/changePasswordActions.js
// module id = 1675
// module chunks = 0